<template>
    <div style="color: #ffffff">
        <div v-for="item in itemList" :key="item.key" class="item">
            <i :class="'iconfont'+item.icon " ></i>
            <span class="total-title">
                <p>{{item.title}}</p>
                <p class="title-unit">{{item.enName}}</p>
            </span>
            <span class="ds-digital-bold" style="margin-left:10px;font-size:24px">
                <animated-integer :value="item.num"></animated-integer>
            </span>
        </div>
    </div>
</template>
<script>
import animatedInteger from '@/components/maComponents/animated-integer';
export default {
    props: {
        // 图表数据
        itemList: {
            type: Array,
            required: true
        },
    },
    components: {
        animatedInteger
    },
    data() {
        return{
        }
    }
}
</script>
<style scoped>
.total-title{
    color: #85A9DF;
    font-size: 20px;
    font-weight: bold;
    font-family: '微软雅黑';
}
.total-unit{
    color: #019AF3;
    font-size: 12px;
}
.item{
    background:#021F5F;
    /*width: 180px;*/
    padding: 10px 15px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-items: flex-start;
}
.item .iconfont{
    font-size: 44px;
    color: #85A9DF;
}
.total-title p{
    line-height: 1;
    margin-bottom: 5px;
}
.total-title .title-unit{
    font-weight: normal;
    font-size: 12px;
}
</style>